// extracted by mini-css-extract-plugin
export default {"container":"cXveQP0yuVL3Oy75JgAb","title":"ZWcuS0X0SpEZiJnlFa_N","row":"WC4ybMoChzJTRh_SZ7iQ","switch":"cX9bwO4nuTLkPbgPWxfz","note":"ynlaTwNy6DOAwlpxylJw"};